import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsCorierManagementServices } from "../../../../../APIServices/EIWRS/ShipmentManagement/eiwrsCorierManagementServices";

const AddCorierForm = ({
  getStudyCorierRowData,
  countryList,
  stateList,
  cityList,
  setCountryId,
  setStateId
}) => {
  let { studyId } = useParams();
  const [corierColumns, setCorierColumns] = useState([]);
  const [corierRow, setCorierRow] = useState("");
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudyCorierColumnData = async (e) => {
    setLoader(true);
    let data = await eiwrsCorierManagementServices.getStudyCorierColumnData(
      "active",
      studyId
    );
    setCorierColumns(data?.data || []);
    setLoader(false);
  };

  const handleCorierRowChange = (e, columnKey) => {
    setCorierRow({
      ...corierRow,
      [columnKey]: e.target.value,
    });
  };

  const addNewStudyCorierRow = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.corierRow = corierRow;
    let data = await eiwrsCorierManagementServices.addNewStudyCorierRow(
      userData
    );
    if (data?.statusCode === 200) {
      clearForm();
      getStudyCorierColumnData();
      getStudyCorierRowData();
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    clearForm();
    getStudyCorierColumnData();
  }, []);

  const clearForm = () => {
    setCorierRow("");
  };

  function isRowDataComplete() {
    return corierColumns.every((col) => {
      const key = col.columnName;
      return (
        corierRow.hasOwnProperty(key) &&
        corierRow[key] !== "" &&
        corierRow[key] !== null &&
        corierRow[key] !== undefined
      );
    });
  }

  return (
    <>
      {loader ? (
        <PageLoader />
      ) : corierColumns?.length === 0 ? (
        <div className="hstack justify-content-center h-100">
          <NoDataFoundTable MSG={"First create corier metadata"} />
        </div>
      ) : (
        <div className="p-2">
          {corierColumns?.map((item, index) => (
            <Form.Group key={index} className="mb-1">
              <Form.Label className="fw-bold mb-1">
                {item?.columnLabel}{" "}
                {item?.required === "yes" &&
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                }
              </Form.Label>
              {item?.columnType === "dropdown" ? (
                <>
                  {item?.customOption === "yes" ?
                    <>
                      {item?.columnName === "COUNTRY" ?
                        <Form.Select
                          value={corierRow?.[item?.columnName]}
                          onChange={(e) => { handleCorierRowChange(e, item?.columnName); setCountryId(e.target[e.target.selectedIndex].title) }}
                          className="br3" style={{ fontSize: 12 }}>
                          <option value="">Select Country</option>
                          {countryList?.map((el, i) => (
                            <option index={i} value={el?.name} title={el.id}>{el?.name}</option>
                          ))}
                        </Form.Select>
                        : item?.columnName === "STATE" ?
                          <Form.Select
                            value={corierRow?.[item?.columnName]}
                            disabled={stateList?.length === 0}
                            onChange={(e) => { handleCorierRowChange(e, item?.columnName); setStateId(e.target[e.target.selectedIndex].title) }}
                            className="br3" style={{ fontSize: 12 }}>
                            <option value="">Select State</option>
                            {stateList?.map((el, i) => (
                              <option index={i} value={el?.name} title={el.id}>{el?.name}</option>
                            ))}
                          </Form.Select>
                          : item?.columnName === "CITY" &&
                          <Form.Select
                            value={corierRow?.[item?.columnName]}
                            disabled={cityList?.length === 0}
                            onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                            className="br3" style={{ fontSize: 12 }}>
                            <option value="">Select City</option>
                            {cityList?.map((el, i) => (
                              <option index={i} value={el?.name}>{el?.name}</option>
                            ))}
                          </Form.Select>
                      }
                    </>
                    :
                    <Form.Select
                      onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                      className="br3"
                      style={{ fontSize: 12 }}
                    >
                      <option value="">Select Option</option>
                      {(item?.columnOption || [])?.map((el, i) => (
                        <option
                          index={i}
                          selected={corierRow[item?.columnName] === el?.option}
                          value={el?.option}
                        >
                          {el?.option}
                        </option>
                      ))}
                    </Form.Select>
                  }
                </>
              ) : item?.columnType === "radio" ? (
                (item?.columnOption || [])?.map((el, i) => (
                  <Form.Check
                    key={i}
                    type="radio"
                    label={el?.option}
                    name={item?.columnName}
                    value={el?.option}
                    checked={corierRow[item?.columnName] === el?.option}
                    onChange={(e) =>
                      handleCorierRowChange(e, item?.columnName)
                    }
                    className="br3"
                  />
                ))
              ) : (
                item?.columnType === "textarea" ?
                  <Form.Control
                    onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                    value={corierRow[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    as={item?.columnType}
                  />
                  :
                  <Form.Control
                    onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                    value={corierRow[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    type={item?.columnType}
                  />
              )}
            </Form.Group>
          ))}
          <div className="text-end">
            <button
              disabled={!isRowDataComplete() || buttonLoader}
              title={
                !isRowDataComplete ? "Fill all required fields" : "Add Corier"
              }
              onClick={addNewStudyCorierRow}
              className={`updateProfile`}
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Adding...
                </div>
              ) : (
                "Add corier"
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AddCorierForm;
